import CoursesTableTab from './courses-table-tab/courses-table-tab.vue';
import store from '@/services/store';
import router from 'vue-router';

export default {
    name: 'Courses',
    components: { CoursesTableTab },
    data() { return {} },
    methods: {},
    mounted() {
        var user = store.getters.getCurrentUser;
        if (user && user.roles && user.roles.length) {
            if (user.roles.some(function (el) { return el === "Admin"; })) {
                this.$router.push({ path: "/admin/courses" });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/courses/courses-tabs/courses.js